import React from 'react';
import { Theme, ThemeVariant } from '@websites/model';

export const ThemeContext = React.createContext<Theme>(
  new Theme(ThemeVariant.spring)
);
